module.exports = __webpack_public_path__ + "img/aprendiz.43785951.png";